(function () {
  'use strict';

  angular.module('app').component('hotelListSearch', hotelListSearch());

  function hotelListSearch() {
    return {
      bindings: {
        onHotelSelected: '&',
        hotelIdSelected: '<',
        hotels: '<',
        showHotelsSearch: '<',
      },
      controller: HotelListSearchComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/hotels/components/hotel-list-search/hotel-list-search.component.html',
    };
  }

  HotelListSearchComponent.$inject = ['UtilService', 'HotelService'];

  function HotelListSearchComponent(UtilService, HotelService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.filterByText = null;

    // Methods
    vm.filterHotels = filterHotels;
    vm.clearSearch = clearSearch;
    vm.selectHotel = selectHotel;

    vm.$onInit = function () {
      if (!vm.hotelIdSelected) {
        getHotels();
      }
    };

    function getHotels() {
      let params = {
        get: 'active',
        search: true,
        taxes: true,
        skip_check_role: true,
      };

      vm.loadingHotels = true;
      HotelService.getHotels(params).then(function (data) {
        vm.hotels = data.items.filter((hotel) => hotel.hotel_rooms.length > 0);

        // order by order for future implementations

        vm.hotelsCopy = angular.copy(vm.hotels);
        vm.loadingHotels = false;
      });
    }

    function filterHotels() {
      // if (vm.filterByText === ''){
      //     vm.hotels = vm.hotelsCopy;
      //     return;
      // }

      // let filterByText = vm.filterByText.toLowerCase();
      // vm.hotels = vm.hotels.filter((hotel) => hotel.name.toLowerCase().match(filterByText));

      vm.hotels = vm.filterByText
        ? vm.hotels.filter((hotel) => hotel.name.toLowerCase().match(vm.filterByText.toLowerCase()))
        : vm.hotelsCopy;
    }

    function clearSearch() {
      vm.filterByText = '';
      vm.hotels = vm.hotelsCopy;
    }

    function selectHotel(hotel) {
      // Avoid calling the date of it is the same schedule
      if (vm.hotelIdSelected === hotel.id) return;

      vm.hotelIdSelected = hotel.id;

      vm.onHotelSelected({
        hotel: hotel,
      });
    }
  }
})();
